// removed by extract-text-webpack-plugin
module.exports = {"pdpFolderItem":"PdpFolderItem-style__pdpFolderItem__9afe5690"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Favorites/PdpFolderItem-style.scss
// module id = 3407
// module chunks = 7